const recurlyFieldNames = {
  cvv: 'cvv',
  month: 'month',
  year: 'year',
  number: 'number',
  card: 'card',
  expiration: 'expiration',
};

export default recurlyFieldNames;
